const Flickity = require('flickity');

export default () => {

    const videos = document.querySelectorAll('[data-videos]');
    for (const video of videos) {
        const flickity = new Flickity(video, {
            cellAlign: 'left',
            contain: true,
            prevNextButtons: true,
            pageDots: true,
            // autoPlay: 5000
        });
    }

}
